import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild
} from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import {ActivatedRoute, NavigationEnd, ParamMap, Params, Router} from '@angular/router';
import {PriceField, ProductService} from "../../../Services/product.service";
import {WissalstoreService} from "../../../Services/wissalstore.service";

@Component({
    selector: 'app-price-filter',
    templateUrl: './price-filter.component.html',
    styleUrls: ['./price-filter.component.scss'],
    standalone: false
})
export class PriceFilterComponent implements OnInit {

  @ViewChild('maxInput', {static: true}) maxInput?: ElementRef;
  @ViewChild('minInput', {static: true}) minInput?: ElementRef;
  maxPrice: number=0;
  minPrice: number = 0;
  sliderMaxPrice: number=0;
  sliderOptions: Options = {
    floor: 0,
    ceil: this.sliderMaxPrice,
    translate: (value: number): string => `${value} DA`,
    getSelectionBarColor: () => '#003147',
  };
  priceExpanded = false;

  showFilterBtn = false;

  constructor(private route: ActivatedRoute, private router: Router,private productService: ProductService,private wissalstoreService: WissalstoreService) { }

  ngOnInit(): void {

    this.productService
      .myMaxPrice
      .subscribe(price =>
        {
          this.sliderMaxPrice=price;
          this.maxPrice=price;
          this.sliderOptions = {
            floor: 0,
            ceil: price,
            translate: (value: number): string => `${value} DA`,
            getSelectionBarColor: () => '#003147',
          };
        }
      );
  }
  sliderListener() {
    //TODO to be reviewed
    this.productService.mySubject.next(new PriceField(this.minPrice,this.maxPrice));
   /* if (this.sliderMaxPrice != undefined) {
      this.selectedPrice.emit(this.sliderMaxPrice);
      this.sliderOptions = {
        floor: 0,
        ceil: this.maxPrice,
        translate: (value: number): string => `${value} DA`,
        getSelectionBarColor: () => '#003147',
      };
    }*/
  }

  /**
   * in case applying filter by clicking on the button
   */
  applyFilter(){
    this.sliderOptions.ceil=this.maxPrice=this.maxInput?.nativeElement.value;
    this.sliderOptions.floor=this.minPrice=this.minInput?.nativeElement.value;

    this.productService.mySubject.next(new PriceField(this.minPrice,this.maxPrice));
    //TODO to be discussed 17/12/2020

    const params: Params = {
      minPrice: this.minPrice,
      maxPrice: this.maxPrice,
    };

    this.router.navigate(['./'], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge',
    });

  }
/*
  ngOnChanges(changes: SimpleChanges): void {
    console.log('My ceil chng '+    this.sliderOptions.ceil);
    //this.test_price = this.maxPrice;
   // this.sliderOptions.ceil = this.maxPrice;
  }*/
  hideSideNavFilter(){
    this.wissalstoreService.sideNavOpen = false;
  }
}
